import { useRef, useEffect, useState } from "react";
import { labelCls } from "./booking/ui";

export const SignaturePad = ({ label, onChange, testid }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [signed, setSigned] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0a0a0a";
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const start = (e) => {
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    setSigned(true);
  };
  const end = () => {
    if (drawing.current) {
      drawing.current = false;
      onChange(canvasRef.current.toDataURL("image/png"));
    }
  };
  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setSigned(false);
    onChange(null);
  };

  return (
    <div>
      <p className={labelCls}>{label}</p>
      <canvas
        ref={canvasRef}
        className="h-40 w-full cursor-crosshair touch-none border border-line bg-white"
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        data-testid={testid}
      />
      <div className="mt-2 flex items-center justify-between">
        <span className="text-xs text-slate-500">{signed ? "Signed" : "Sign here"}</span>
        <button type="button" onClick={clear} className="text-xs font-bold uppercase tracking-widest text-blaze" data-testid={`${testid}-clear`}>
          Clear
        </button>
      </div>
    </div>
  );
};
